import PedidosFormComponent from "@/components/pos/PedidosFormComponent";
import PedidoViewComponent from "@/components/pos/PedidoViewComponent";

import PedidosMayoreoFormComponent from "@/components/pos/pos_mayoreo/PedidosMayoreoFormComponent";
import PedidoMayoreoViewComponent from "@/components/pos/pos_mayoreo/PedidoMayoreoViewComponent";

import PosComponent from "@/components/pos/pos_servicios/PosComponent";
import PosViewComponent from "@/components/pos/pos_servicios/PosViewComponent";

import CotizacionesComponent from "@/components/pos/cotizaciones/CotizacionesComponent";
import CotizacionesViewComponent from "@/components/pos/cotizaciones/CotizacionesViewComponent";

import CotizacionMovilComponent from "@/components/pos/cotizacion_movil/CotizacionMovilComponent";
import CotizacionMovilEscaneoComponent from "@/components/pos/cotizacion_movil/CotizacionMovilEscaneoComponent";

import CuponeraComponent from "@/components/pos/cuponera/CuponeraComponent";
import CuponeraFormComponent from "@/components/pos/cuponera/CuponeraFormComponent";

export default [
  {
    path: "/pos/pedidos/",
    name: "pos-pedidos",
    component: PedidosFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/pos/pedidos/:id/ver/",
    name: "pos-pedidos-ver",
    component: PedidoViewComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/pos/pedidos-mayoreo/",
    name: "pos-pedidos-mayoreo",
    component: PedidosMayoreoFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/pos/pedidos-mayoreo/:id/ver/",
    name: "pos-pedidos-mayoreo-ver",
    component: PedidoMayoreoViewComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/pos/venta/",
    name: "pos-venta",
    component: PosComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/pos/venta/:id/ver/",
    name: "pos-venta-ver",
    component: PosViewComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/pos/cotizaciones/",
    name: "pos-cotizaciones",
    component: CotizacionesComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/pos/cotizaciones/:id",
    name: "pos-cotizaciones-editar",
    component: CotizacionesViewComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/pos/cotizacion-movil/",
    name: "pos-cotizacion-movil",
    component: CotizacionMovilComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/pos/cotizacion-movil/:tipo/:id",
    name: "pos-cotizacion-movil-escaneo",
    component: CotizacionMovilEscaneoComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/pos/cuponera/",
    name: "pos-cuponera",
    component: CuponeraComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/pos/cuponera/:id",
    name: "pos-cuponera-editar",
    component: CuponeraFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/pos/cuponera-nuevo/",
    name: "pos-cuponera-nuevo",
    component: CuponeraFormComponent,
    meta: {
      requiresAuth: true,
    },
  },
];
